import { render, staticRenderFns } from "./treeCateCard.vue?vue&type=template&id=765b10ea&scoped=true&"
import script from "./treeCateCard.vue?vue&type=script&lang=js&"
export * from "./treeCateCard.vue?vue&type=script&lang=js&"
import style0 from "./treeCateCard.vue?vue&type=style&index=0&id=765b10ea&prod&lang=scss&"
import style1 from "./treecatecard.scss?vue&type=style&index=1&id=765b10ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b10ea",
  null
  
)

export default component.exports